import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Alert, Button } from 'antd';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Form as FormikForm, FormItem, Radio } from 'formik-antd';
import { ErrorMessage, FieldArray } from 'formik';

import { Fieldset } from 'components/form';

import StagePropTypes from './prop-types';
import CompanyAdminField from './company-admin-field';

import { DB_PREFIX } from './constants';

const Form = ({ children, values }) => {
  const {
    [DB_PREFIX]: { isGroup, users },
  } = values;

  return (
    <FormikForm layout="vertical">
      <FormItem
        label="Are you registering for a group?"
        name={`${DB_PREFIX}.isGroup`}
      >
        <Radio.Group defaultValue="" name={`${DB_PREFIX}.isGroup`}>
          <Radio.Button value>Yes</Radio.Button>
          <Radio.Button value={false}>No</Radio.Button>
        </Radio.Group>
      </FormItem>

      <ErrorMessage name={`${DB_PREFIX}`}>
        {(msg) => {
          if (Array.isArray(msg.users)) return null;
          return (
            <>
              {msg.users ? (
                <Alert message={msg.users} type="error" showIcon />
              ) : null}
              <Divider />
            </>
          );
        }}
      </ErrorMessage>

      {isGroup ? (
        <FieldArray
          name={`${DB_PREFIX}.users`}
          render={({ push, remove }) => {
            return (
              <>
                {users.map((admin, i) => {
                  const last = i === users.length - 1;
                  return (
                    <React.Fragment key={i}>
                      <CompanyAdminField i={i} last={last} />
                      <Fieldset>
                        <Button
                          type="danger"
                          className="dynamic-delete-button"
                          style={{ width: '100%' }}
                          onClick={() => remove(i)}
                        >
                          <MinusCircleOutlined className="dynamic-delete-button" />
                          Delete admin
                        </Button>

                        {last ? (
                          <Button
                            style={{ width: '100%' }}
                            type="dashed"
                            onClick={() =>
                              push({
                                name: '',
                                date: null,
                              })
                            }
                          >
                            <PlusCircleOutlined /> Add admin
                          </Button>
                        ) : null}
                      </Fieldset>
                    </React.Fragment>
                  );
                })}

                {users.length === 0 ? (
                  <Fieldset>
                    <Button
                      style={{ width: '100%' }}
                      type="dashed"
                      onClick={() =>
                        push({
                          name: '',
                          email: '',
                        })
                      }
                    >
                      <PlusCircleOutlined /> Add admin
                    </Button>
                  </Fieldset>
                ) : null}
              </>
            );
          }}
        />
      ) : null}

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
};

Form.defaultProps = {
  children: null,
};

export default Form;
